module.exports = __webpack_public_path__ + "static/media/icon-email-grey.055e74d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-email-grey.svg
// module id = 930
// module chunks = 0